import { render, staticRenderFns } from "./shop_tj.vue?vue&type=template&id=40b44aa4&scoped=true"
import script from "./shop_tj.vue?vue&type=script&lang=js"
export * from "./shop_tj.vue?vue&type=script&lang=js"
import style0 from "./shop_tj.vue?vue&type=style&index=0&id=40b44aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b44aa4",
  null
  
)

export default component.exports